import { Home, Play, Clock } from 'lucide-react'
import './BottomTabs.css'

const tabs = [
  { key: 'home', label: 'Home', icon: Home },
  { key: 'play', label: 'Play', icon: Play },
  { key: 'history', label: 'History', icon: Clock },
]

export default function MainNav({ activeTab, onNavigate }) {
  return (
    <nav className="bottom-tabs">
      {tabs.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          className={`bottom-tab ${activeTab === key ? 'active' : ''}`}
          onClick={() => onNavigate(key)}
        >
          <Icon size={22} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  )
}
